module.exports = __webpack_public_path__ + "static/media/typ@3x.d061db80.png";